import { CustomerAccount } from '@proximus/common-business-logic';

export function isFlsAu(customerAccount: CustomerAccount): boolean {
  return !!(customerAccount.flsDefaultCustomer && customerAccount.flsDefaultCustomer.payer);
}

export function isMcsAu(customerAccount: CustomerAccount): boolean {
  return !!(customerAccount.mcsDefaultCustomer && customerAccount.mcsDefaultCustomer.payer);
}

export function isAu(customerAccount: CustomerAccount): boolean {
  return isMcsAu(customerAccount) || isFlsAu(customerAccount);
}
